import { render, staticRenderFns } from "./CaculatorGuide.vue?vue&type=template&id=0ca7b848&scoped=true&"
import script from "./CaculatorGuide.vue?vue&type=script&lang=js&"
export * from "./CaculatorGuide.vue?vue&type=script&lang=js&"
import style0 from "./CaculatorGuide.vue?vue&type=style&index=0&id=0ca7b848&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7b848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca7b848')) {
      api.createRecord('0ca7b848', component.options)
    } else {
      api.reload('0ca7b848', component.options)
    }
    module.hot.accept("./CaculatorGuide.vue?vue&type=template&id=0ca7b848&scoped=true&", function () {
      api.rerender('0ca7b848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay_guide/CaculatorGuide.vue"
export default component.exports